import { HTTP as http } from '../../http';
import { BASE_URL_APP as baseUrl } from '../../http/baseUrl';
import {swall} from '../../services/sweetAlert';
const logout = async () => {
    await http.get('/logout')
    window.location.href = baseUrl;
}
export default {
    async logout(user_id, company_id, {message}) {
        if(JSON.parse(sessionStorage.getItem('login')) == true){
            sessionStorage.setItem('login', false);
            swall(message, true, 'exclamation-circle', 'secondary',5, logout)
        }
    },
    async getToken() {
        return await http.get('/socket/get-token');
    },

    async checkLogin(user_id, company_id, {message}) {
        await http.get('/auth/check').catch(e => console.log(e))
    }
}
